import Api from '../../Api';
import { IAction } from '../../shared-interfaces/Notation/IAction';
import { IMethodOfContact } from '../../shared-interfaces/Notation/IMethodOfContact';
import { INotationComment } from '../../shared-interfaces/Notation/INotationComment';
import { ICoreUser } from '../../shared-interfaces/User/ICoreUser';

const DataInsightService = {
  getComments: async (id: number): Promise<INotationComment[]> => {
    const response = await Api.get(`notation/data-insight/${id}/comments`);
    return response.data.map((x: any) => ({
      ...x,
      createdOn: new Date(x.createdOn),
      modifiedOn: new Date(x.modifiedOn),
    })) as INotationComment[];
  },
  addComment: async (
    id: number,
    action: IAction,
    details: string,
    assignedTo?: ICoreUser,
    methodOfContact?: IMethodOfContact,
  ): Promise<void> => {
    await Api.post(`notation/data-insight/${id}/comment`, {
      actionId: action.id,
      details: details,
      methodOfContactId: methodOfContact?.id,
      assignedToId: assignedTo?.id,
    });
  },
  delete: async (id: number): Promise<void> => {
    await Api.delete(`notation/data-insight/${id}`);
  },
  deleteComment: async (
    notationId: number,
    commentId: number,
  ): Promise<void> => {
    await Api.delete(
      `notation/data-insight/${notationId}/comment/${commentId}`,
    );
  },
};

export default DataInsightService;
